// ─── Social Links ─────────────────────────────────────────────────────────────
export const SOCIAL_LINKS = {
  instagram:   'https://www.instagram.com/_solopov_132/',
  linkedin:    'https://www.linkedin.com/in/konstantinsolopov',
  reelcrafter: 'https://play.reelcrafter.com/Hs4sX9mISsi-Vh0iL8J9UQ',
  email:       'mailto:ks.score.sound@gmail.com',
} as const;
